import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { CoreUiModule } from "@obg/ngx.ui.core";

import { PrimaryToolbarComponent } from "./primary-toolbar.component";

@NgModule({
	imports: [CommonModule, MatButtonModule, CoreUiModule],
	exports: [PrimaryToolbarComponent],
	declarations: [PrimaryToolbarComponent],
})
export class PrimaryToolbarModule {}
